import { useMemo } from "react";

/**
 * Search -> status filter -> template filter, over the full unpaginated
 * collection (CalendarsController::index() returns everything, no
 * server-side search/filter). Sort stays on the existing useSortableTable
 * mechanism, applied by the caller on top of this hook's output — sort
 * order doesn't change which rows are in the set, so keeping it separate
 * avoids re-deriving sort comparator logic here.
 */
export function useCalendarsFilterSort(collection, { search, statusValues, templateValues }) {
  return useMemo(() => {
    let rows = collection;

    const query = search.trim().toLowerCase();
    if (query) {
      rows = rows.filter((calendar) => calendar.name.toLowerCase().includes(query));
    }

    if (statusValues.length) {
      rows = rows.filter((calendar) =>
        statusValues.includes(calendar.available ? "published" : "unpublished")
      );
    }

    if (templateValues.length) {
      rows = rows.filter((calendar) => templateValues.includes(calendar.template));
    }

    return rows;
  }, [collection, search, statusValues, templateValues]);
}
